import { Component } from '@angular/core';

@Component({
  selector: 'pds-loader',
  template: `<div class="loader"></div>`,
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class PDSLoaderComponent {}
